import {Route,Switch,BrowserRouter } from "react-router-dom";

import DoobiHeader from "components/Headers/DoobiHeader";
import ProSubscriptionPackagesTable from "components/Doobi/ProSubscriptionPackages";
import ProSubscriptionFeaturesTable from "components/Doobi/ProSubscriptionFeatures";

const ProSubscriptionPackagesRoute = ({ match }) => {
  return (
    <>
  <DoobiHeader section="Pro Subscription Packages" />
    <BrowserRouter>
    <Switch>
      <Route path={`${match.path}/features/:id`} component={ProSubscriptionFeaturesTable}/>
      <Route path={`${match.path}/`} component={ProSubscriptionPackagesTable}/>
    </Switch>
    </BrowserRouter>
    </>
    );
  }; 


export default ProSubscriptionPackagesRoute;
